import { SocialMediaLinksProps } from "./SocialMedia";

export function buildSocialMedia(apiModel: any): SocialMediaLinksProps {
	if (apiModel) {
		const twitter = apiModel["Twitter"];
		const linkedIn = apiModel["Linkedin"];

		const socialMediaInfo = {
			twitter: {
				id: twitter ? twitter["@id"] || "" : "",
				link: twitter?.link || "",
				label: twitter?.label || "",
				openInNewWindow: twitter?.openInNewWindow || false,
				isVisible: twitter?.isVisible || false,
			},
			linkedIn: {
				id: linkedIn ? linkedIn["@id"] || "" : "",
				link: linkedIn?.link || "",
				label: linkedIn?.label || "",
				openInNewWindow: linkedIn?.openInNewWindow || false,
				isVisible: linkedIn?.isVisible || false,
			},
		};

		return socialMediaInfo;
	}

	return {
		twitter: {
			id: "",
			link: "",
			label: "",
			openInNewWindow: false,
			isVisible: false,
		},
		linkedIn: {
			id: "",
			link: "",
			label: "",
			openInNewWindow: false,
			isVisible: false,
		},
	};
}
